import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Button, Calendar } from '@/components/ui';
import { useQueryParams } from '@/hooks';
import { CircleX } from 'lucide-react';
import { cn } from '@/lib/utils';
import dayjs from 'dayjs';

type TProps = {
  defaultValue?: string | Date;
  removable?: boolean;
  disabled?: boolean;
  paramName: string;
  format?: string;
  title?: string;
  text?: string;
};

const DateFilter = ({ paramName, disabled, title, defaultValue, removable = false, text = 'Date', format = 'YYYY-MM-DD' }: TProps) => {

  const { values: [currentValue], deleteValue, setValue } = useQueryParams([paramName], { [paramName]: defaultValue });

  const selectedDate = (
    currentValue && dayjs(currentValue).isValid()
      ? dayjs(currentValue).toDate()
      : undefined
  );

  const enableRemoveButton = removable && selectedDate;

  const handleOnSelectDate = (newDate?: Date) => {
    newDate = newDate ?? new Date();
    const dateString = dayjs(newDate).format(format);
    setValue(paramName, dateString);
  };

  const handleOnClickBtnReset = () =>
    deleteValue(paramName);

  return (
    <div className='flex items-center my-auto'>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            className={cn(
              'flex items-center space-x-1 border border-dashed text-xs',
              enableRemoveButton && 'border-r-0 rounded-r-none'
            )}
            variant={selectedDate ? 'secondary' : 'ghost'}
            disabled={disabled}
            title={title}
            size={'sm'}>
            <div className='flex items-center'>
              {text}
              {
                selectedDate &&
                <span>:</span>
              }
            </div>
            {
              selectedDate &&
              <span className='text-purple-600 font-semibold'>
                {dayjs(selectedDate).format(format)}
              </span>
            }
          </Button>
        </PopoverTrigger>
        <PopoverContent className='w-auto p-0'>
          <Calendar
            mode='single'
            selected={selectedDate}
            onSelect={handleOnSelectDate}
            autoFocus />
        </PopoverContent>
      </Popover>
      {
        enableRemoveButton &&
        <Button
          className='space-x-1 border border-dashed border-l-0 rounded-l-none text-xs'
          onClick={handleOnClickBtnReset}
          title='Supprimer le filtre'
          variant={'secondary'}
          disabled={disabled}
          size={'sm'}>
          <CircleX size={16} />
        </Button>
      }
    </div>
  );

};

export default DateFilter;
